import cn from 'classnames';
import {
  PropsWithClassName,
  PropsWithClassNameAndChildren,
} from '@orionprotocol/utils';

import styles from './Placeholder.module.scss';

function Root({ className }: PropsWithClassName): JSX.Element {
  return <div className={cn(className, styles.placeholder)} />;
}

function Basic({
  className,
  children,
  ready,
}: PropsWithClassNameAndChildren<{ ready: boolean }>): JSX.Element {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return ready ? <>{children}</> : <Root className={className} />;
}

export const Placeholder = Object.assign(Root, { Basic });
